import React, { useState } from 'react'
import Icon from 'components/elements/Icon'

import { getScryfallImageUrl } from 'utils/ImageUrl'

import type { CardType } from 'types/deck'
import DeckService from 'services/deck.service'
import { useActionless, useAppSelector } from 'app-redux/hooks'
import { DECK_PATCH_SUCCEEDED } from 'app-redux/deck/actions/types'
import RequestService from 'services/request.service'
import PhatButton from 'components/formElements/PhatButton'
import SimpleSpinner from 'components/elements/SimpleSpinner'

type Props = {
  card: CardType
  flipped?: boolean
  disabled?: boolean
}

const SetDeckImageButton = ({ card, flipped = false, disabled }: Props) => {
  const deckId = useAppSelector(state => state.deck.id)
  const customFeatured = useAppSelector(state => state.deck.customFeatured)

  const [deckPatchSucceeded] = useActionless(DECK_PATCH_SUCCEEDED)
  const [loading, setLoading] = useState(false)

  const setCustomDeckImage = () => {
    const customFeatured = getScryfallImageUrl(card.uid, flipped, 'art_crop', card.scryfallImageHash)

    const body = { customFeatured }

    setLoading(true)

    DeckService.update(deckId, body)
      .then(_data => deckPatchSucceeded(body))
      .catch(RequestService.createToast)
      .finally(() => {
        // without the timeout, the loader is removed too fast otherwise most of the time
        setTimeout(() => setLoading(false), 1000)
      })
  }

  const alreadySet = getScryfallImageUrl(card.uid, flipped, 'art_crop', card.scryfallImageHash) === customFeatured

  return (
    <PhatButton
      disabled={disabled || alreadySet || loading || !!card.customCard || card.contentWarning}
      onClick={setCustomDeckImage}>
      {!loading && (
        <>
          <Icon name="image outline" /> Set Deck Image
        </>
      )}

      {loading && (
        <>
          <SimpleSpinner size="medXSmall" /> Set Deck Image
        </>
      )}
    </PhatButton>
  )
}

export default SetDeckImageButton
